import {Observable} from "rxjs";
import {MarketMoversStateRecord} from "../types/MarketMoversState";
import {MarketMoversService} from "../service/MarketMoversService";
import {MarketMoverModelFactory} from "../service/MarketMoverModelFactory";
import {MarketMoversModel, MarketMoversStateModel} from "../models/MarketMoversStateModel";

const RefreshIntervalSeconds = 15;
const RefreshInterval = RefreshIntervalSeconds * 1000;

export class MarketMoversStore {

    public static readonly id = "marketMoversStore";

    private readonly state$: Observable<MarketMoversStateModel>;
    private readonly top200$: Observable<MarketMoversModel>;
    private readonly all$: Observable<MarketMoversModel>;

    /** @ngInject */
    public constructor(private readonly marketMoversService: MarketMoversService,
                       private readonly marketMoverModelFactory: MarketMoverModelFactory) {
        this.state$ = this.buildState();
        this.top200$ = this.buildTop200();
        this.all$ = this.buildAll();
    }

    private buildState(): Observable<MarketMoversStateModel> {
        return Observable.timer(0, RefreshInterval)
                         .switchMap(() => this.retrieveState())
                         .map((r) => this.marketMoverModelFactory.build(r))
                         .publishReplay(1)
                         .refCount();
    }

    private retrieveState(): Observable<MarketMoversStateRecord> {
        return Observable.fromPromise(this.marketMoversService.latest())
                         .catch(() => Observable.empty());
    }

    private buildTop200(): Observable<MarketMoversModel> {
        return this.state$
                   .map((s) => s.top200)
                   .publishReplay(1)
                   .refCount();
    }

    private buildAll(): Observable<MarketMoversModel> {
        return this.state$
                   .map((s) => s.all)
                   .publishReplay(1)
                   .refCount();
    }

    public get top200(): Observable<MarketMoversModel> {
        return this.top200$;
    }

    public get all(): Observable<MarketMoversModel> {
        return this.all$;
    }
}
